<div>
  <form [formGroup]="chargeListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row">
          <span class="__filter_icon" style="background-color: white;">
          </span>
          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Charge
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        <div class="table-scroll-container">
          @if (viewPermission) {
            <table mat-table matSort [dataSource]="chargeDataSource" (matSortChange)="sortData($event)" >
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Charge Code</span>
                    <input placeholder="Search by Code" type="search" matInput
                      autocomplete="off" formControlName="code" class="mat-input-custom">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.code}}</td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Charge Name</span>
                      <input placeholder="Search by Name" type="search" matInput
                        autocomplete="off" formControlName="name" class="mat-input-custom">
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.name}}</td>
                  </ng-container>
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>Charge Type</span>
                        <mat-select formControlName="type" placeholder="Search by Type">
                          @for (c of chargeTypes; track c) {
                            <mat-option [value]="c.key">
                              {{c.label}}
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.type}}</td>
                  </ng-container>
                  <ng-container matColumnDef="unitType">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>Unit Type</span>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.unitType}}</td>
                  </ng-container>
                  <ng-container matColumnDef="chargeCategory">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>Charge Category</span>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.chargeCategory}}</td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>Status</span>
                        <mat-select formControlName="status" placeholder="Search by Status">
                          @for (status of statusTypes; track status) {
                            <mat-option [value]="status.key">
                              {{status.label}}
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.status}}</td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <span mat-sort-header>Action</span></th>
                      <td mat-cell *matCellDef="let element">
                        <span class="__action_edit_icon" (click)="openForm(element.id)">
                          <mat-icon mat-cell>create</mat-icon>
                        </span>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="chargeColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: chargeColumns;"></tr>
                  </table>
                }
              </div>
            </mat-card-content>
          </mat-card>
          @if (viewPermission) {
            <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [length]="totalRecords"></mat-paginator>
          }
        </form>
      </div>